"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlFromEndpoint = exports.getMethodFromEndpoint = exports.endpointTypes = void 0;
exports.endpointTypes = {
    add: "POST",
    get: "GET",
    update: "PUT",
    remove: "DELETE",
};
function getMethodFromEndpoint(endpoint) {
    let method = null;
    Object.keys(exports.endpointTypes).forEach(start => {
        if (endpoint.startsWith(start)) {
            method = exports.endpointTypes[start];
        }
    });
    if (method === null) {
        throw new Error(`Wrong definition of endpoint "${endpoint}", it has to start with ${Object.keys(exports.endpointTypes)}.`);
    }
    else {
        return method;
    }
}
exports.getMethodFromEndpoint = getMethodFromEndpoint;
function getUrlFromEndpoint(endpoint) {
    let url = endpoint;
    Object.keys(exports.endpointTypes).forEach(start => {
        if (endpoint.startsWith(start)) {
            url = endpoint.substring(start.length);
        }
    });
    return "/api/" + getKebabCase(url);
}
exports.getUrlFromEndpoint = getUrlFromEndpoint;
function getKebabCase(input) {
    return input
        .split("")
        .map((char, i) => {
        if (char === char.toUpperCase()) {
            if (i === 0) {
                return char.toLowerCase();
            }
            else {
                return `-${char.toLowerCase()}`;
            }
        }
        else {
            return char;
        }
    })
        .join("");
}
